module.exports = __webpack_public_path__ + "h5/img/login.5f156ed4.gif";